export default __webpack_public_path__ + "static/1588-7dd0034180789974d3af4c6024c14dbc.gif";